import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { GoldButton } from "./GoldButton";
import { Reveal, MaskedLine } from "./Reveal";

const PILLARS = ["Fede", "Mente", "Corpo"];

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="relative overflow-hidden px-5 py-32 sm:px-8 lg:py-48" data-testid="final-cta-section">
      <motion.div className="absolute inset-0" style={{ y: imgY }}>
        <img
          src="https://images.pexels.com/photos/5648779/pexels-photo-5648779.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920"
          alt=""
          className="h-[120%] w-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-night via-night/70 to-night" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-6xl text-center">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.45em] text-gold" data-testid="final-cta-overheadline">Sei pronto?</p>
        </Reveal>

        <h2 className="mt-8 font-display font-bold uppercase leading-[1.02] tracking-tight" data-testid="final-cta-headline">
          <MaskedLine delay={0.1} className="text-5xl text-ivory sm:text-7xl lg:text-8xl">40 giorni</MaskedLine>
          <MaskedLine delay={0.25} className="text-5xl text-ivory sm:text-7xl lg:text-8xl">per tornare</MaskedLine>
          <MaskedLine delay={0.4} className="text-5xl sm:text-7xl lg:text-8xl">
            <span className="text-gold">a costruire.</span>
          </MaskedLine>
        </h2>

        <div className="mt-16 flex items-center justify-center gap-5 sm:gap-10" data-testid="final-cta-pillars">
          {PILLARS.map((p, i) => (
            <motion.span
              key={p}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.5 + i * 0.15 }}
              className="flex items-center gap-5 sm:gap-10"
            >
              <span className="font-display text-2xl font-bold uppercase tracking-[0.2em] text-transparent [-webkit-text-stroke:1px_rgba(245,245,240,0.7)] sm:text-4xl lg:text-5xl">
                {p}
              </span>
              {i < PILLARS.length - 1 && <span className="h-2 w-2 rotate-45 bg-gold" />}
            </motion.span>
          ))}
        </div>

        <Reveal delay={0.7} className="mx-auto mt-14 max-w-xl">
          <p className="text-base uppercase tracking-[0.2em] leading-relaxed text-ivory/70 sm:text-lg">
            Il Deserto è gratuito.
            <br />
            Il viaggio può continuare molto oltre il giorno 40.
          </p>
        </Reveal>

        <Reveal delay={0.85} className="mt-14">
          <GoldButton testId="final-cta-button" size="lg">
            Entra nella Sfida del Deserto
          </GoldButton>
          <p className="mt-5 text-xs uppercase tracking-[0.2em] text-ivory/40" data-testid="final-cta-microcopy">
            Inizia gratuitamente. Nessun abbonamento necessario.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
